import React, { useEffect, useState } from 'react'
import { reactWidgetWrapper } from 'live/widgets/decorators/react'
import FlowRate from './FlowRate'
import widgetService from 'live/services/widgets'
import { reducer } from './dataReducer'

function RealModel(props: LiveReactChartProps<ChartStateFluid, ChartMessageFluid, Configs>): JSX.Element {
    return <FlowRate height={props.height} width={props.width} values={props.state?.value?.values} />
}

widgetService.register({
    get type() {
        return 'real_model_value'
    },
    get name() {
        return 'Real x Model Valuec'
    },
    get description() {
        return 'A card that compares the real time value with the value from the model. If the is an optimumFlow it will be displayed aside.'
    },
    config: {},
    policies: {
        defaultReducer: '@latest'
    },
    // the wrapper is needed to enable the reducer mechanism and comply the API
    impl: reactWidgetWrapper<ChartStateFluid, ChartMessageFluid, Configs>(RealModel, reducer)
})
